mutation RequestAccountDeletion($accountId: ID, $email: String, $suspendedReviewed: Boolean) {
  result: StreamToolsRequestAccountDeletion(accountId: $accountId, email: $email, suspendedReviewed: $suspendedReviewed) {
    accountId
    status
    requestedAt
    completedAt
    wasSuspended
    steps
  }
}
